/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Creating_ProjectInputs */



/**
* | output |
* | --- |
* | "Creating project" |
*
* @param {Chat_Tool_Creating_ProjectInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_creating_project = /** @type {((inputs?: Chat_Tool_Creating_ProjectInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Creating_ProjectInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Erstelle Projekt")
	return /** @type {LocalizedString} */ ("Creating project")
});